'use strict';

var SV = require('server-vars');
var endpoints = require('dibs-endpoints');

var _require = require('./util'),
    addHeaders = _require.addHeaders,
    addTokenToUrl = _require.addTokenToUrl,
    conditionalPromiseHelpers = _require.conditionalPromiseHelpers,
    fetchWrapper = _require.fetchWrapper;

function getPhoto(itemId, photoId) {
    var url = addTokenToUrl(endpoints.graphQL() + '/');

    var itemPhotoQuery = '{\n        viewer {\n            item (itemId: "' + itemId + '") {\n                photos(photoId: "' + photoId + '") {\n                    apiType\n                    id\n                    serviceId\n                    format {\n                        apiType\n                        name\n                    }\n                    sortOrder\n                    source {\n                        apiType\n                        name\n                    }\n                    status\n                    versions {\n                        apiType\n                        type {\n                            apiType\n                            name\n                        }\n                        webPath\n                    }\n                    masterOrZoomPath\n                }\n            }\n        }\n    }';

    var payload = {
        query: itemPhotoQuery
    };

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(payload)
    })).then(function (response) {
        return response.data.viewer.item.photos[0];
    });
}

function uploadPhoto(itemId, data) {
    var url = addTokenToUrl(endpoints.itemImageUpload(), { itemId: itemId });

    return fetchWrapper(url, {
        method: 'post',
        body: data
    });
}

function processPhoto(itemId, photoId, data) {
    var url = addTokenToUrl(endpoints.processImage(itemId, photoId));

    return fetchWrapper(url, addHeaders({
        method: 'post',
        body: JSON.stringify(data)
    })).then(function () {
        return getPhoto(itemId, photoId);
    });
}

exports.uploadPhoto = function (_ref) {
    var payload = _ref.payload,
        _ref$onStart = _ref.onStart,
        onStart = _ref$onStart === undefined ? function () {} : _ref$onStart,
        _ref$onSuccess = _ref.onSuccess,
        onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
        _ref$onFail = _ref.onFail,
        onFail = _ref$onFail === undefined ? function () {} : _ref$onFail;
    var file = payload.file,
        _payload$errorMessage = payload.errorMessages,
        errorMessages = _payload$errorMessage === undefined ? {} : _payload$errorMessage,
        _payload$formDataFact = payload.formDataFactory,
        formDataFactory = _payload$formDataFact === undefined ? function () {
        return new FormData();
    } : _payload$formDataFact,
        itemId = payload.itemId;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe.ok,
            fail = _conditionalPromiseHe.fail,
            failIfAny = _conditionalPromiseHe.failIfAny;

        var possibleErrors = [[!(file && file.name), { message: errorMessages.fileNotSpecified || 'File was not specified.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        var formData = formDataFactory();

        // Append the file (multipart/formdata)
        formData.append('files', file);

        var upload = function upload() {
            onStart({ filename: file.name });
            return uploadPhoto(itemId, formData);
        };

        upload().then(function (response) {
            ok({ photo: response.result });
        }).catch(function (err) {
            fail(err);
        });
    });
};

exports.rotatePhoto = function (_ref2) {
    var payload = _ref2.payload,
        _ref2$onSuccess = _ref2.onSuccess,
        onSuccess = _ref2$onSuccess === undefined ? function () {} : _ref2$onSuccess,
        _ref2$onFail = _ref2.onFail,
        onFail = _ref2$onFail === undefined ? function () {} : _ref2$onFail;
    var degree = payload.degree,
        itemId = payload.itemId,
        imageId = payload.imageId,
        _payload$errorMessage2 = payload.errorMessages,
        errorMessages = _payload$errorMessage2 === undefined ? {} : _payload$errorMessage2;


    return new Promise(function (resolve, reject) {
        var _conditionalPromiseHe2 = conditionalPromiseHelpers(resolve, reject, onSuccess, onFail),
            ok = _conditionalPromiseHe2.ok,
            fail = _conditionalPromiseHe2.fail,
            failIfAny = _conditionalPromiseHe2.failIfAny;

        var possibleErrors = [[!itemId, { message: errorMessages.itemIdNotSpecified || 'Item ID was not specified.' }], [!imageId, { message: errorMessages.imageIdNotSpecified || 'Image ID was not specified.' }], [typeof degree !== 'number', { message: errorMessages.nonNumericDegree || 'Degree must be a number.' }]];

        if (failIfAny(possibleErrors)) {
            return;
        }

        var data = {
            apiType: 'imageRotationRequest',
            type: 'ROTATION',
            degree: degree
        };

        processPhoto(itemId, imageId, data).then(function (response) {
            ok(response);
        }).catch(function (err) {
            fail(err);
        });
    });
};